/* @flow */
// typecheck: ignore file
import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Redirect from 'components/Redirect.jsx';

type Props = {
  loading: boolean,
  user?: {
    role: string,
    sign_in_count: number,
    featureFlags: { web_admin_console: boolean },
    admin_organizations: [],
    pending_organizations: [],
  },
};

function AppLanding(props: Props) {
  const { loading, user } = props;

  if (loading) {
    return null;
  }

  if (!user) {
    return <Redirect to="/log_in" />;
  }

  if (!user.role) {
    return <Redirect to="/join/role_picker" />;
  }

  const somethingToShowInAdminConsole = (
    user.admin_organizations.length > 0 ||
    user.pending_organizations.length > 0
  );

  if (somethingToShowInAdminConsole && user.sign_in_count > 1 && user.featureFlags['web_admin_console']) {
    return <Redirect to="/admin/landing" />;
  }

  return <Redirect to="/classes" />;
}

const withEverythingTheComponentNeeds = graphql(gql`
  query {
    app_landing_user: me {
      id
      role
      sign_in_count
      featureFlags {
        web_admin_console
      }
      admin_organizations: organizations(first: 1, affiliation_status: [admin]) {
        id
      }
      pending_organizations: organizations(first: 1, affiliation_status: [pending_admin]) {
        id
      }
    }
  }`, {
    props: ({ data }) => ({ user: data.app_landing_user, loading: data.loading }),
    options: { forceFetch: true },
  }
);

export { AppLanding };
export default withEverythingTheComponentNeeds(AppLanding);



// WEBPACK FOOTER //
// ./src/app/components/AppLanding.jsx